import store from '@/store'
import { StoreProvider as EasyPeasyStoreProvider } from 'easy-peasy'

export function StoreProvider({ children }: { children: React.ReactNode}) {
  return (<EasyPeasyStoreProvider store={store}>{children}</EasyPeasyStoreProvider>)
}
